export default __webpack_public_path__ + "static/media/nexum-200x200.2dabffeb.svg";